'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Server = function (_React$Component) {
    _inherits(Server, _React$Component);

    function Server() {
        _classCallCheck(this, Server);

        return _possibleConstructorReturn(this, (Server.__proto__ || Object.getPrototypeOf(Server)).apply(this, arguments));
    }

    _createClass(Server, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.593 9.126v-0.474c0-2.057-1.674-3.731-3.731-3.731h-18.131c-2.057 0-3.731 1.674-3.731 3.731v0.474c0 1.446 0.828 2.699 2.033 3.319-1.205 0.619-2.033 1.872-2.033 3.318v0.474c0 1.446 0.828 2.699 2.033 3.319-1.205 0.619-2.033 1.872-2.033 3.318v0.474c0 2.058 1.674 3.731 3.731 3.731h18.132c2.057 0 3.731-1.674 3.731-3.731v-0.474c0-1.446-0.828-2.699-2.033-3.318 1.205-0.619 2.033-1.873 2.033-3.319v-0.474c0-1.446-0.828-2.699-2.033-3.318 1.205-0.619 2.033-1.872 2.033-3.318zM24.768 22.874v0.474c0 1.602-1.303 2.906-2.906 2.906h-18.131c-1.602-0-2.906-1.304-2.906-2.906v-0.474c0-1.602 1.303-2.906 2.906-2.906h18.132c1.602 0 2.905 1.304 2.905 2.906zM24.768 15.763v0.474c0 1.602-1.303 2.906-2.906 2.906h-18.131c-1.602-0-2.906-1.304-2.906-2.906v-0.474c0-1.602 1.303-2.906 2.906-2.906h18.132c1.602 0 2.905 1.304 2.905 2.906zM21.862 12.032h-18.131c-1.602 0-2.906-1.304-2.906-2.906v-0.474c0-1.602 1.303-2.906 2.906-2.906h18.132c1.602 0 2.906 1.303 2.906 2.906v0.474c-0 1.602-1.304 2.906-2.906 2.906z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.881 6.864c-1.117 0-2.025 0.908-2.025 2.025s0.908 2.025 2.025 2.025 2.025-0.908 2.025-2.025-0.908-2.025-2.025-2.025zM20.881 10.089c-0.661 0-1.199-0.538-1.199-1.199s0.538-1.199 1.199-1.199 1.199 0.538 1.199 1.199-0.538 1.199-1.199 1.199z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M2.687 16c0 1.117 0.908 2.025 2.025 2.025s2.025-0.908 2.025-2.025-0.908-2.025-2.025-2.025-2.025 0.908-2.025 2.025zM4.712 14.801c0.661 0 1.199 0.538 1.199 1.199s-0.538 1.199-1.199 1.199-1.199-0.538-1.199-1.199 0.538-1.199 1.199-1.199z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.881 25.135c1.117 0 2.025-0.908 2.025-2.025s-0.908-2.025-2.025-2.025-2.025 0.908-2.025 2.025 0.908 2.025 2.025 2.025zM20.881 21.911c0.661 0 1.199 0.538 1.199 1.199s-0.538 1.199-1.199 1.199-1.199-0.538-1.199-1.199 0.538-1.199 1.199-1.199z' })
            );
        }
    }]);

    return Server;
}(_react2.default.Component);

Server.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Server;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/server.js
// module id = 1123
// module chunks = 0